import React, { Component } from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Card } from 'tmt-ui-kit';

// import SeeMoreCard from './SeeMoreCard';
import Link from '~/components/Link/Link';
import { actions as tripActions } from '~/redux/reducers/trip';
import { actions as popupActions } from '~/redux/reducers/popup';
import { actions as appActions } from '~/redux/reducers/app';
import config from '~/config';

import { isDusitApp } from '~/utils/helpers';

const SeeMoreCard = dynamic(() => import(/* webpackChunkName: "Card.SeeMoreCard.components" */'./SeeMoreCard'), { loading: () => null });

const enhance = connect(
  ({ session, info, app }) => ({
    sessionData: session.data,
    rates: info.exchangeRates,
    omitBookingFee: true,
    isMobile: app.isMobile,
  }),
  {
    openVideo: tripActions.openVideo,
    openTourCategory: popupActions.openTourCategory,
    globalLoad: appActions.loading,
  }
);

class TicketCard extends Component {
  static propTypes = {
    isMobile: PropTypes.bool,
    data: PropTypes.object,
    sessionData: PropTypes.object,
    rates: PropTypes.object,
    seeMore: PropTypes.string,
    globalLoad: PropTypes.func,
  };

  onBuyNow = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const { isMobile, data } = this.props;
    if (isMobile || isDusitApp()) this.props.globalLoad();
    window.location.href = `${config.baseURL.en}/booking/new?trip=${data.slug}&device=${isMobile ? 'mobile' : 'desktop'}&requestType=book`;
    return false;
  }

  render() {
    const { isMobile, data, sessionData, rates, seeMore } = this.props;
    if (seeMore) {
      return <SeeMoreCard seeMore={seeMore} />;
    }
    const { currency } = sessionData;
    const isNewTab = !(isMobile || isDusitApp());
    return (
      <Link
        to={data.slug ? `/ticket/${data.slug}` : '/'}
        className="link"
        target={isNewTab ? '_blank' : '_self'}
        {...isNewTab ? { rel: 'noopener noreferrer' } : {}}
      >
        <Card.TicketCard
          data={data}
          rates={rates}
          currency={currency}
          onClickBookButton={(e) => this.onBuyNow(e)}
        />
      </Link>
    );
  }
}

export default enhance(TicketCard);
